import { render, staticRenderFns } from "./IconSend.vue?vue&type=template&id=71c9b476"
import script from "./IconSend.vue?vue&type=script&lang=js"
export * from "./IconSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports